export const STATUSES = [
  "Application Received",
  "Pre-Screen Invitation Sent",
  "Pre-Screen In Progress",
  "Pre-Screen Submitted",
  "Administrative Review",
  "Additional Information Requested",
  "Approved to Advance",
  "Not Selected to Advance",
  "Training Access Granted",
  "Training In Progress",
  "Training Completed",
  "Ready for Final Interview/Onboarding",
  "Hired — Onboarding",
  "Onboarding Complete",
];

// Statuses shown on the applicant progress tracker (linear journey)
export const APPLICANT_JOURNEY = [
  "Application Received",
  "Pre-Screen In Progress",
  "Pre-Screen Submitted",
  "Administrative Review",
  "Approved to Advance",
  "Training Access Granted",
  "Training In Progress",
  "Training Completed",
  "Ready for Final Interview/Onboarding",
  "Hired — Onboarding",
  "Onboarding Complete",
];

export const ADMIN_FLAGS = [
  "EDUCATION VERIFICATION REQUIRED",
  "QMHP-CS QUALIFICATION REVIEW",
  "LICENSE VERIFICATION REQUIRED",
  "CANS/ANSA VERIFICATION REQUIRED",
  "DOCUMENTATION CONCERN",
  "SCOPE/JUDGMENT CONCERN",
  "BILLING COMPLIANCE CONCERN",
  "ADDITIONAL INFORMATION NEEDED",
  "STRONG CANDIDATE",
];

export const SCORE_CATEGORIES = [
  { key: "cat1", label: "Education / Qualification Alignment", max: 20 },
  { key: "cat2", label: "Relevant Mental & Behavioral Health Experience", max: 20 },
  { key: "cat3", label: "Professional Judgment / Scope Awareness", max: 15 },
  { key: "cat4", label: "Treatment Plan Application", max: 20 },
  { key: "cat5", label: "Documentation Competency", max: 20 },
  { key: "cat6", label: "Professionalism / Following Instructions", max: 5 },
];

export function decisionBand(total) {
  if (total == null) return null;
  if (total >= 85) return { label: "STRONG CANDIDATE", tone: "success" };
  if (total >= 75) return { label: "ADVANCE / REVIEW", tone: "primary" };
  if (total >= 65) return { label: "SECONDARY REVIEW REQUIRED", tone: "warning" };
  return { label: "DO NOT ADVANCE", tone: "danger" };
}

export function statusTone(status) {
  const map = {
    "Approved to Advance": "success",
    "Training Access Granted": "success",
    "Training Completed": "success",
    "Ready for Final Interview/Onboarding": "success",
    "Hired — Onboarding": "primary",
    "Onboarding Complete": "success",
    "Not Selected to Advance": "danger",
    "Additional Information Requested": "warning",
    "Administrative Review": "primary",
    "Pre-Screen Submitted": "primary",
    "Training In Progress": "primary",
  };
  return map[status] || "muted";
}
